export const MBA_EXTRA_VIDEO_KEYS = ["video-eran"];

export const MBA_INDUSTRY_CEOS_TITLE = "מנכ״לים מהתעשייה שהשתתפו במהלך הקורסים הקודמים";

export const MBA_INDUSTRY_CEOS = [
  {
    imageKey: "ceo-guy-taubin",
    name: "גיא טאובין",
    role: "מנכ״ל EvE Investment Banking",
  },
  {
    imageKey: "ceo-jackie-zamro",
    name: "ג׳קי זמרו",
    role: "מנכ״ל פקר שפי",
  },
  {
    imageKey: "ceo-viktoria-kanar",
    name: "ויקטוריה כנר",
    role: "מנכ״לית Re-Fresh Global",
  },
  {
    imageKey: "ceo-sharon-israel",
    name: "שרון ישראל",
    role: "מנכ״לית Extra Mile",
  },
  {
    imageKey: "ceo-shlomo-schreibman",
    name: "שלמה שרייבמן",
    role: "מנכ״ל Growth-Kiflayim",
  },
];

export const MBA_SESSIONS_TITLE = "קצת מהמפגשים";

export const MBA_SESSION_PHOTOS = [
  { imageKey: "session-01", alt: "ד״ר משה קטן בהרצאה בקורס פיתוח מנהיגות" },
  { imageKey: "session-02", alt: "שיחה בכיתה במהלך מפגש הקורס" },
  { imageKey: "session-03", alt: "מבט מהכיתה על המפגש" },
  { imageKey: "session-04", alt: "ד״ר משה קטן במפגש עם הסטודנטים" },
  { imageKey: "session-05", alt: "סטודנטים בפעילות במהלך המפגש" },
  { imageKey: "session-06", alt: "הרצאה באולם הקורס" },
  { imageKey: "session-07", alt: "פתיחת מפגש פיתוח מנהיגות" },
];
